import { AxiosPromise, AxiosResponse } from 'axios';
import Resource from 'src/services/api-client/resource/base/Resource';

type FileHeaders = {
  Accept?: string
};
export default class FileResource extends Resource {
  constructor() {
    super('');
  }

  public get(fileName: string): AxiosPromise {
    const url: string = fileName;

    const headers: FileHeaders = {
        ...this.httpClient.defaults.headers,
        'Accept': '*/*',
    };
    
    this.getHeaders();

    return this.httpClient
      .get(url, {
        responseType: 'blob',
        headers
      }).then((response: AxiosResponse<File>): AxiosResponse<File> => {
      try {
        return response as AxiosResponse<File>;
      } catch (e) {
        // tslint:disable-next-line: no-console
        console.error(e);
        throw e;
      }
    });
  }
}


// WEBPACK FOOTER //
// ./src/services/api-client/resource/FileResource.tsx